<template>
      <div class="columns">
          <div class="column" v-for="item in items" :key="item._id">
              <ProductCard :item="item" />
          </div>
      </div>
</template>

<script>
import ProductCard from './ProductCard';

export default {
    props: ['items'],
    components: {
        ProductCard
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cards/ProductCards.vue